import React, { useEffect, useState } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import api, { apiErrorMessage } from "../services/api";

export const CardPayButton = ({ promoCode = null, channel = "perso", disabled, onError, testid = "stripe-pay-btn" }) => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/payments/stripe/config").then(({ data }) => setCfg(data)).catch(() => setCfg({ configured: false })); }, []);
  if (!cfg?.configured) return null;

  const pay = async () => {
    setBusy(true); onError?.("");
    try {
      const { data } = await api.post("/payments/stripe/checkout", { origin_url: window.location.origin, promo_code: promoCode, channel });
      window.location.href = data.checkout_url;
    } catch (err) {
      onError?.(apiErrorMessage(err, "Le paiement par carte est indisponible pour le moment."));
      setBusy(false);
    }
  };

  return (
    <div className="mt-5">
      <button onClick={pay} disabled={disabled || busy} data-testid={testid} className="btn-orange btn-shine w-full rounded-xl py-3.5 font-bold text-[15px] flex items-center justify-center gap-2 disabled:opacity-70">
        {busy ? <Loader2 className="animate-spin" size={18} /> : <CreditCard size={18} />} Payer par carte bancaire
      </button>
      <div className="flex flex-wrap items-center justify-center gap-2 mt-2 text-[11px] text-slate-500">
        <span className="px-1.5 py-0.5 rounded bg-white/5 border border-white/10 text-slate-300 font-semibold whitespace-nowrap">Apple Pay</span>
        <span className="px-1.5 py-0.5 rounded bg-white/5 border border-white/10 text-slate-300 font-semibold whitespace-nowrap">Google Pay</span>
        <span className="px-1.5 py-0.5 rounded bg-white/5 border border-white/10 text-slate-300 font-semibold whitespace-nowrap">Visa · Mastercard · CB</span>
        <span>· Paiement sécurisé Stripe</span>
      </div>
      <div className="flex items-center gap-3 my-4 text-[12px] text-slate-500"><span className="flex-1 h-px bg-[#222735]" /> ou <span className="flex-1 h-px bg-[#222735]" /></div>
    </div>
  );
};

export default CardPayButton;
